import { ChevronDownIcon,ChevronUpIcon } from '@heroicons/react/24/outline';

import { Icon } from '../Icon';

const GridSortingCaret = ({ direction, index }: { direction: 'asc' | 'desc' | false, index: number }) => {

    if (!direction) {
        return null;
    }

    return direction === 'asc' ?
        <>
            <Icon className="tw-ml-auto" icon={ChevronUpIcon} size="md" />
            <span className="tw-text-xs tw-mx-1">{index + 1}</span>
        </>
        :
        <>
            <Icon className="tw-ml-auto" icon={ChevronDownIcon} size="md" />
            <span className="tw-text-xs tw-mx-1">{index + 1}</span>
        </>;
};

export { GridSortingCaret };
